import { Component } from '@angular/core';

@Component({
    templateUrl: 'standard-layout.component.html',
    standalone: false
})
export class StandardLayoutComponent {
  constructor() {}
}
